import { render } from "./PreavvisiSospSolleciti.vue?vue&type=template&id=6dd72e30&scoped=true"
import script from "./PreavvisiSospSolleciti.vue?vue&type=script&lang=js"
export * from "./PreavvisiSospSolleciti.vue?vue&type=script&lang=js"

import "./PreavvisiSospSolleciti.vue?vue&type=style&index=0&id=6dd72e30&scoped=true&lang=css"

import exportComponent from "/Users/andreacotugno/Documents/AGF-Workspace/ask_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dd72e30"]])

export default __exports__